import HTTP from "../HTTP";
import Jsona from "jsona";
import orderHelpers from "../helpers/orders";
import paramsHelpers from "../helpers/params";
import JSONAPIHelpers from "../helpers/JSONAPI";
import ordersList from "@/store/modules/orders/list";

const dataFormatter = new Jsona();

export default {
  async getList() {
    try {
      let textSearch = ordersList.state.search;
      let number = ordersList.state.options.page;
      let size = ordersList.state.options.itemsPerPage;
      let user = ordersList.state.user;
      let fields = ordersList.state.options.sortBy;
      let desc = ordersList.state.options.sortDesc;

      let includes = [
        "cycle",
        "schedule_event",
        "professional.account.profile",
        "customer.account.profile",
        "address.district.city.state",
        "amount"
      ];

      let filters = [
        {
          name: "text_search",
          value: textSearch
        }
      ];

      let dataParams = {
        includes,
        filters,
        sort: { fields, desc },
        pagination: { number, size }
      };

      let params = paramsHelpers.buildParams(dataParams);
      let url = `orders${params}`;

      if (JSONAPIHelpers.isAValidAccountable(user))
        url = `${user.type}/${user.id}/${url}`;

      let results = await HTTP.normal.get(url);

      return {
        data: dataFormatter.deserialize(results.data),
        totalItems: results.data.meta.record_count
      };
    } catch (e) {
      throw "Ocorreu um erro ao buscar o histórico de pedidos!";
    }
  },

  async index(opts) {
    try {
      let includes =
        "cycle," +
        "schedule_event," +
        "professional.account.profile," +
        "customer.account.profile," +
        "address.district.city.state";
      let search = opts.textSearch
        ? `&filter[text_search]=${opts.textSearch}`
        : "";
      let pagination = paramsHelpers.buildPaginationParams(opts.pagination);
      let user = opts.user ? `${opts.user.type}/${opts.user.id}/` : "";

      let results = await HTTP.normal.get(
        `${user}orders?include=${includes}${search}${pagination}`
      );

      return {
        data: dataFormatter.deserialize(results.data),
        totalItems: results.data.meta.record_count
      };
    } catch (e) {
      throw "Ocorreu um erro ao listar os pedidos!";
    }
  },

  async updateDescription(order) {
    try {
      let data = {
        data: {
          id: order.id,
          type: "orders",
          attributes: {
            description: order.description
          }
        }
      };

      await HTTP.normal.patch(`/orders/${order.id}`, data);
    } catch (e) {
      throw e;
    }
  },

  async getById(id) {
    let includes = [
      "schedule_event",
      "professional.account.profile",
      "professional.account.phones",
      "customer.account.profile",
      "customer.account.phones",
      "address.district.city.state.country",
      "address.district.pricing",
      "amount",
      "payments",
      "payments.funding_instrument",
      "events"
    ].join(",");

    try {
      let res = await HTTP.normal.get(`/orders/${id}?include=${includes}`);
      return dataFormatter.deserialize(res.data);
    } catch (error) {
      throw "Ocorreu um erro ao buscar o pedido!";
    }
  },

  async getByEvent(eventID) {
    try {
      let res = await HTTP.normal.get(
        `schedule-events/${eventID}/order?include=schedule_event`
      );
      return dataFormatter.deserialize(res.data);
    } catch (error) {
      throw "Ocorreu um erro ao buscar o pedido!";
    }
  },

  async create(payload) {
    try {
      let order = await HTTP.normal.post("/orders", payload);
      return dataFormatter.deserialize(order.data);
    } catch (e) {
      throw "Ocorreu um erro ao criar o pedido!";
    }
  },

  async cancel(orderId) {
    try {
      let res = await HTTP.normal.post(`/orders/${orderId}/cancel-order`);
      return dataFormatter.deserialize(res.data);
    } catch (error) {
      throw "Ocorreu um erro ao cancelar o pedido!";
    }
  },

  async setServiceNotProvided(orderId) {
    try {
      let res = await HTTP.normal.post(
        `management/orders/${orderId}/inform-service-not-provided`
      );
      return dataFormatter.deserialize(res.data);
    } catch (error) {
      throw "Ocorreu um erro ao colocar o pedido como crédito!";
    }
  },

  async restoreOrderToPaid(orderId) {
    try {
      let response = await HTTP.normal.post(
        `management/orders/${orderId}/restore-to-paid`
      );
      return dataFormatter.deserialize(response.data);
    } catch (error) {
      throw "Ocorreu um erro ao restaurar o pedido para pago!";
    }
  },

  async confirmPayment(orderId) {
    try {
      let res = await HTTP.normal.post(
        `management/orders/${orderId}/confirm-order-payment`
      );
      return dataFormatter.deserialize(res.data);
    } catch (error) {
      throw "Ocorreu um erro ao confirmar o pagamento!";
    }
  },

  async rebook(payload) {
    try {
      let res = await HTTP.normal.post(
        "/order-rebookings",
        orderHelpers.buildRebookingRequestBody(payload)
      );
      await HTTP.normal.post(
        `/order-rebookings/${res.data.data.id}/rebook`,
        orderHelpers.buildRescheduleRequestBody(payload)
      );
    } catch (e) {
      throw "Ocorreu um erro ao remarcar o pedido!";
    }
  },

  async reschedule(payload) {
    try {
      let res = await HTTP.normal.post(
        "/order-reschedulings",
        orderHelpers.buildReschedulingRequestBody(payload)
      );
      await HTTP.normal.post(
        `/order-reschedulings/${res.data.data.id}/reschedule`,
        orderHelpers.buildRescheduleRequestBody(payload)
      );
    } catch (e) {
      throw "Ocorreu um erro ao reagendar o pedido!";
    }
  }
};



// WEBPACK FOOTER //
// ./src/API/modules/orders.js